// src/App.tsx
import { useEffect, useRef} from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { ServerSwitch } from './components/ui/ServerSwitch';
// i18n
import './i18n';
import { updateLanguageFromUser } from './i18n';
// Routes
import DashboardRoutes from './routes/dashboard.routes';
// Welcome Page
import Welcome from './pages/Welcome';
// Contexts
import { AuthProvider } from './context/AuthContext';
import { WindowProvider } from './context/WindowContext';
import { ProtectedRoute } from './context/ProtextedRoute'
import { SupportProvider } from './context/SupportContext';
// Auth Pages
import LoginPage from './pages/auth/LoginPage';
import SignUpPage from './pages/auth/SignUpPage';
import VerifyEmailPage from './pages/auth/VerifyEmailPage';
import EmailVerifiedPage from './pages/auth/EmailVerifiedPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import ResendCodePage from './pages/auth/ResendCodePage';
import PasswordResetSuccessPage from './pages/auth/PasswordResetSuccessPage';
// Onboarding
import { getOnboardingStatus } from './store/authReducer';
import OnboardingForm from './pages/onboarding/OnboardingForm';
import CorporateOnboarding from './pages/onboarding/corporate/CorporateOnboarding';
import {store} from './store'
import { Provider } from 'react-redux'
import { useWindow } from './context/WindowContext';
import type { AppDispatch, RootState } from './store';
import { getMainWallets, getCryptoWallets, getMasterCardData, getMasterCardBalance, updateAssetsStatus, getZenusAccount } from './store/assetsReducer';
import { getExchangeRates } from './store/settingReducer';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      retryDelay: 1000,
      staleTime: 30000,
      gcTime: 10000,
    },
  },
});
function App() {
  // NUEVO: Limpiar estado previo al cargar la aplicación
  // const { windowWidth } = useWindow();
  const hasRun = useRef(false);
  const token = localStorage.getItem('token');
  const dispatch = useDispatch<AppDispatch>();
   const { data: { cryptoPrices, fiatPrices }, status: rateStatus } = useSelector((state: RootState) => state.setting);
  useEffect(() => {
    const init = async () => {
    // if(!hasRun.current){
      if (rateStatus === "idle") {
        hasRun.current = true;
        const result = await dispatch(getExchangeRates()).unwrap();
      }else{
        dispatch(getExchangeRates()).unwrap();
      }

    // }
  };
   if(!hasRun.current){
      init();
       if(token){
        // Check if user is CORPORATE first
        const user = localStorage.getItem('user');
        if (user) {
          try {
            const userData = JSON.parse(user);
            // Only call getOnboardingStatus for EXPRESS and INDIVIDUAL users
            // CORPORATE users use the web form, not SUBUTAI
            if (userData.accountType !== 'CORPORATE') {
              const pathParts = window.location.pathname.split('/');
              const referralCode = pathParts.find(part => part.match(/^[A-Z0-9]{6,}$/));
              dispatch(getOnboardingStatus(referralCode)).unwrap();
            }
          } catch (e) {
            console.error('Error parsing user data:', e);
          }
        }
      }
   }
  setInterval(init, 10 * 60 * 1000);
  }, []);


  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SupportProvider>
          <WindowProvider >
            <Router
              future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true
              }}
            >
            {/* Server Switch - Solo visible en desarrollo local */}
            {window.location.hostname === 'localhost' && <ServerSwitch floating={true} />}
            
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
            <Routes>
              {/* Auth Routes - Public */}
              <Route path="/" element={<LoginPage />} />
              <Route path="/signup" element={<SignUpPage />} />
              <Route path="/register" element={<SignUpPage />} />
              <Route path="/verify-email" element={<VerifyEmailPage />} />
              <Route path="/email-verified" element={<EmailVerifiedPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/resend-code" element={<ResendCodePage />} />
              <Route path="/password-reset-success" element={<PasswordResetSuccessPage />} />
              <Route path="/welcome" element={<Welcome />} />

              {/* Protected Routes */}
              <Route path="/onboarding"
                element={
                  <ProtectedRoute>
                    <OnboardingForm />
                  </ProtectedRoute>
                }
              />

              {/* Corporate Onboarding Form */}
              <Route path="/onboarding/corporate"
                element={
                  <ProtectedRoute>
                    <CorporateOnboarding />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/dashboard/*"
                element={
                  <ProtectedRoute>
                    <DashboardRoutes />
                  </ProtectedRoute>
                }
              />

              {/* Referral Code Route - captures code from URL path */}
              <Route path="/:referralCode" element={<SignUpPage />} />
              
              {/* Catch all route - 404 */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </WindowProvider>
        </SupportProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;